var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.abTestGroup === 0 || _vm.abTestGroup === 1 || _vm.isEURegion)?_c('TemplateLibraryV2'):(_vm.abTestGroup===2)?_c('TemplateLibraryV3'):_c('TemplateLibraryV3p2')}
var staticRenderFns = []

export { render, staticRenderFns }